import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentService, ComponentTypeService } from './services';
import { CompensationsService } from './services/compensations.service';

const angularModules = [CommonModule];
const thirdPartyModules = [];

const services = [
  ComponentTypeService,
  ComponentService,
  CompensationsService,
];

const guards = [];
const sharedComponents = [];
const pipes = [];

@NgModule({
  imports: [
    ...angularModules,
    ...thirdPartyModules
  ],
  exports: [
    ...angularModules,
    ...thirdPartyModules,
    ...sharedComponents,
    ...pipes
  ],
  declarations: [
    ...sharedComponents,
    ...pipes,

  ],
  providers: [
    ...services,
    ...guards
  ]
})
export class CarModule { }
